import script from "./FormDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./FormDatePicker.vue?vue&type=style&index=0&id=59325897&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59325897"]])

export default __exports__